document.addEventListener('alpine:init', () => {
  Alpine.data('scrollBar', () => ({
    visible: false,
    lastScrollY: 0,
    buttonTop: 0,

    init() {
      const btn = document.querySelector('.product-form__submit');
      if (!btn) return;

      this.buttonTop = btn.getBoundingClientRect().top + window.scrollY;

      window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;

        if (currentScroll > this.buttonTop) {
          this.visible = true;
        } else {
          this.visible = false;
        }

        this.lastScrollY = currentScroll;
      });
    }
  }));
});